<span
  class="marker"
  [ngClass]="type || ''"
  [ngStyle]="{ backgroundColor: color }"
></span>
